module.exports = __webpack_public_path__ + "img/3.73227d0b.jpg";